import { ReactNode } from 'react';
import Drawer from '@mui/material/Drawer';
import { zIndex, ZIndexSizeType } from 'presentations/views/styles';
interface Props {
  children: ReactNode;
  isOpen: boolean;
  onClose?: any;
  className?: string;
  anchor?: 'right' | 'left' | 'top' | 'bottom';
  variant?: 'permanent' | 'persistent' | 'temporary' | undefined;
  zIndex?: ZIndexSizeType;
}
export default function Component(props: Props) {
  return (
    <Drawer
      variant={props.variant}
      anchor={props.anchor || 'left'}
      className={props.className}
      open={props.isOpen}
      onClose={props.onClose}
      style={{ zIndex: zIndex(props.zIndex || 1200) }}
    >
      {props.children}
    </Drawer>
  );
}
